
import { StateCreator } from "zustand";
import { SECURE_AUTH_TOKEN_KEY, SECURE_BASE_URL_KEY, AUTH_HEADER } from "../../../base";
import { getDataKeyFromLocalStorage } from "../../../common/utils/AuthToken";
import Endpoints from "../../../domain/endpoints";
import { FetchState } from "../../../domain/models/fetch-state";
import { AxiosHttpClient } from "../../../infra/http/axios-http-client";
import { FetchTourDeviationApprovalType } from "../../../domain/models/tour-program-approval/fetch-tour-deviation-approval";
import { FetchTourDeviationApproval } from "../../../domain/useages/tour-program-approval/fetch-tour-deviation-approval";
import { RemoteFetchTourDeviationApproval } from "../../../data/usecases/tour-program-approval/remote-fetch-tour-deviation-approval";

export interface FetchTourDeviationApprovalInterface {
  FetchTourDeviationApproval: FetchTourDeviationApprovalType;
  FetchTourDeviationApprovalState: FetchState;
  fetchTourDeviationApproval: Function;
}

const initialStates = {
  FetchTourDeviationApproval: {} as FetchTourDeviationApprovalType,
  FetchTourDeviationApprovalState: FetchState.DEFAULT,
};

const axiosHttpClient = AxiosHttpClient.getInstance();


export const useFetchTourDeviationApprovalSlice: StateCreator<
  FetchTourDeviationApprovalInterface
> = (set) => ({
  ...initialStates,
  fetchTourDeviationApproval: async (filter: FetchTourDeviationApproval.Params) => {
  
    const token = getDataKeyFromLocalStorage(SECURE_AUTH_TOKEN_KEY) ??"";
    const BASE_URL = getDataKeyFromLocalStorage(SECURE_BASE_URL_KEY);

    axiosHttpClient.setAuthHeaders({
      [AUTH_HEADER]: token.toString(),
    });

    const remoteFetchTourDeviationApproval = new RemoteFetchTourDeviationApproval(
      `${BASE_URL}${Endpoints.FETCH_TOUR_DEVIATION_APPROVAL}`,
      axiosHttpClient
    );
    set(() => ({ FetchTourDeviationApprovalState: FetchState.LOADING }));
    let result = await remoteFetchTourDeviationApproval.fetch(filter);
    return result;
  }
});


